import type { Store } from '@revenuecat/purchases-capacitor';

import { PackageType } from '@/integrations/revenuecat/types';
import { getEnvVar } from '@/shared/utils/envVarConfig';

export const ACE_ENTITLEMENT_ID = getEnvVar(
  'VITE_REVENUECAT_ACE_ENTITLEMENT_ID',
  {
    // https://app.revenuecat.com/projects/626bad40/product-catalog/entitlements/entlcff753c89b
    // Should be unmodifiable in most cases
    defaultValue: 'Duos Ace',
  },
);

export const PADDLE_MANAGEMENT_URL = getEnvVar(
  'VITE_REVENUECAT_PADDLE_MANAGEMENT_URL',
  {
    defaultValue:
      'https://sandbox-customer-portal.paddle.com/cpl_01k9zbn5q7bnhj2m6s573kv811',
  },
);

export const periodNames: Record<PackageType, string> = {
  [PackageType.UNKNOWN]: 'Unknown',
  [PackageType.CUSTOM]: 'Custom',
  [PackageType.LIFETIME]: 'Lifetime',
  [PackageType.WEEKLY]: '1 Week',
  [PackageType.MONTHLY]: '1 Month',
  [PackageType.TWO_MONTH]: '2 Months',
  [PackageType.THREE_MONTH]: '3 Months',
  [PackageType.SIX_MONTH]: '6 Months',
  [PackageType.ANNUAL]: '1 Year',
};

export const storeDisplayNames: Record<Store, string> = {
  APP_STORE: 'App Store',
  PLAY_STORE: 'Play Store',
  PADDLE: 'Paddle',

  // Added for completeness, though these are unlikely to be encountered
  AMAZON: 'Amazon Appstore',
  EXTERNAL: 'External Store',
  MAC_APP_STORE: 'Mac App Store',
  PROMOTIONAL: 'Promotional',
  RC_BILLING: 'RevenueCat Billing',
  STRIPE: 'Stripe',
  TEST_STORE: 'Test Store',
  UNKNOWN_STORE: 'Unknown Store',
};

export const CANCELLATION_REASONS = [
  { id: 'price_too_expensive', label: 'Price is too expensive' },
  { id: 'not_enough_value', label: 'Not enough value' },
  { id: 'wanted_to_see_likes', label: 'Wanted to see who liked me' },
  { id: 'just_trying_out', label: 'Was just trying it out' },
  { id: 'subscribe_short_term', label: 'I usually subscribe short-term' },
] as const;

export type CancellationReasonId = (typeof CANCELLATION_REASONS)[number]['id'];
